<template>
  <div>
    <div class="account-confirm">
      <div class="grayHead">
        <span>
          以下の内容でアカウント編集を行います<br>
          お間違いがないかご確認ください
        </span>
      </div>
      <ul class="confirmBox">
        <li>
          <p class="confirmBox__label">認証メールアドレス</p>
          <p>{{ form.mail }}</p>
        </li>
        <li>
          <p class="confirmBox__label">ログインパスワード</p>
          <p>**********</p>
        </li>
        <li>
          <p class="confirmBox__label">氏名</p>
          <p>{{ form.surname + '' + form.first_name }}</p>
        </li>
        <li>
          <p class="confirmBox__label">氏名カナ</p>
          <p>{{ form.surname_kana + '' + form.first_name_kana }}</p>
        </li>
        <li>
          <p class="confirmBox__label">電話番号</p>
          <p>{{ form.tel }}</p>
        </li>
        <li>
          <p class="confirmBox__label">郵便番号</p>
          <p>{{ form.post_code }}</p>
        </li>
        <li>
          <p class="confirmBox__label">都道府県</p>
          <p>{{ prefectureName }}</p>
        </li>
        <li>
          <p class="confirmBox__label">市町村</p>
          <p>{{ form.city_name }}</p>
        </li>
        <li>
          <p class="confirmBox__label">番地・建物名</p>
          <p>{{ form.address }}</p>
        </li>
        <li>
          <p class="confirmBox__label">生年月日</p>
          <p>{{ form.birthday }}</p>
        </li>
      </ul>

      <!-- Error Message -->
      <p
        v-if="validation"
        class="form-valiTxt"
      >
        {{ validation }}
      </p>

      <!-- Submit Button -->
      <div class="confirmBtn">
        <Btn
          :label="'登録'"
          :color="'red'"
          :disable="isLoading"
          class="register-btn"
          @click.native="handleSubmit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/store'
import error from '@/mixin/error.mixin'
import Btn from '@/components/parts/Btn'

export default {
  name: 'AccountEditStep02Confirm',

  mixins: [error],

  components: {
    mapGetters,
    Btn
  },

  data () {
    return {
      validation: ''
    }
  },

  beforeRouteEnter (from, to, next) {
    if (!store.getters['accountEdit/form'].mail) {
      return next({name: 'AccountEditStep01Form'})
    }

    store.commit('loadingAction', false)
    next()
  },

  computed: {
    ...mapGetters(['isLoading']),
    ...mapGetters('prefectures', ['prefectures']),
    ...mapGetters('accountEdit', ['form']),
    prefectureName () {
      const prefecture = this.prefectures.find(e => e.id === this.form.prefecture_id)
      return prefecture ? prefecture.name : ''
    }
  },

  methods: {
    handleSubmit () {
      store.commit('loadingAction', true)
      store.dispatch('accountEdit/updateUser', this.form).then(() => {
        this.$router.push({ name: 'AccountEditStep03Complete' }).catch(() => {})
      }).catch((err) => {
        store.commit('loadingAction', false)
        this.validation = this.getValidateErrorMessage(err)
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import '../../assets/css/commons/confirm.pcss';

  .account-confirm {
    & .form-valiTxt{
      margin: 0 auto;
      max-width: 600px;
      font-size: 14px;
      text-align: center;
      color: #ff0000;
      padding: 15px 20px 0;
    }
    & .confirmBox {
      margin: 0 auto;
      max-width: 600px;
      p {
        word-break: break-all;
      }
    }
    & .confirmBtn {
      margin: 0 auto 15px;
      max-width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/account-edit/Step02Confirm.vue